import {
  DialogBackdrop,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTrigger,
} from "../ui/dialog"
import { Button } from "@chakra-ui/react"
import { colors } from "../../utilities/colors"
import Spinner from "./Spinner"
import { SolidGreenButton, HappyButton, RedButton } from "./Buttons"

export default function ReusableModal({isOpen, onClose, headerText, disabled=null, submitText, loading=null, children, handleSubmit= null, file, dataTestId}) {
  return(
    <DialogRoot
      open={isOpen}
      onOpenChange={onClose}
    >
      <DialogBackdrop />
      <DialogTrigger />
      <DialogContent>
        <DialogHeader
          color={colors.green}
          fontSize={'md'}
          fontWeight={'semibold'}
          data-testid={dataTestId}
          bg={colors.deepOcean}
          borderTopRadius="md"
        >
          {headerText}
        </DialogHeader>
        {onClose && <DialogCloseTrigger aria-label="Close modal"/>}
        <DialogBody bg={colors.deepOcean}>
          {children}
        </DialogBody>
        <DialogFooter
          bg={colors.deepOcean}
          borderBottomRadius="md"
        >
          {handleSubmit &&
            <HappyButton
              text={loading ? <Spinner/> : submitText}
              onClick={handleSubmit}
              disabled={disabled}
              loading={loading}
            />
          }
          {onClose &&
            <RedButton
              text="Close"
              onClick={onClose}
            />
          }
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  )
}